import Pqp from "../3x1010/Pqp.js";
import Labels from "./Labels.js";
import Main from "./Main.js";

export default class InitPano {
	constructor() {
		this.trixScripts = null;
		this.trixScriptIndex = null
		this.trixMain = null
		this.userLang = null
		this.userLangParam = null
		this.startSpot = null
		this.skipwi = null
		this.initedLayout = false;
		this.hot_hotspot = null
		this.edit = false;
		this.scenename = null;
		this.hot_item = null;
		this.url_rewrite = true;
		this.track = false;
		this.that = this;	
	}

	init() {

		// Per ora la lingua di base la prende da qui
		this.userLang = navigator.language || navigator.userLanguage;
		this.userLang = (this.userLang.split("-")[0]).toUpperCase();

		// controlla se è stata passata una lingua
		this.userLangParam = Pqp.getParameterByName("pn");

		// Start spot
		this.startSpot = Pqp.getParameterByName("spot");
		if (this.startSpot) {
			track = true;
		}

		// Skip welcome e istruzioni
		this.skipwi = Pqp.getParameterByName("skip");


		this.track = Pqp.getParameterByName("track");
		if (this.track == "true") {
			this.track = true;
		} else {
			this.track = false;
		}


		// hotspot da aprire
		this.hot_hotspot = Pqp.getParameterByName("hs");
		//startSpot = 18//2//14//7//28//3//28;
		//skipwi = true;

		this.edit = Pqp.getParameterByName("mode");
		if (this.edit == "edit") {
			this.edit = true;
		} else {
			this.edit = false;
		}

		this.scenename = Pqp.getParameterByName("loc");
		if (!this.scenename) {
			this.scenename = 30;
		}




		if (this.edit) {
			this.skipwi = true;
		}


		if (this.hot_hotspot) {
			this.skipwi = true;
		}

		/*
		hot_item = getParameterByName("item");
		if (!hot_hotspot) {
			hot_item = null;
		}
		*/

		// Forza cmq l'url
		let url = document.location.href
		/*if (url.indexOf("?") >= 0) {
			let tmp = url.split("?");
	
	
			url = tmp[0];
		}*/
		url = Pqp.safeReplace(url, "pn=IT", "");
		url = Pqp.safeReplace(url, "pn=EN", "");
		url = Pqp.safeReplace(url, "pn=DE", "");
		url = Pqp.safeReplace(url, "pn=FR", "");
		url = Pqp.safeReplace(url, "pn=ES", "");
		url = Pqp.safeReplace(url, "&&", "&");
		url = Pqp.safeReplace(url, "?&", "?");
		/*if (url.indexOf("?") >= 0) {
			let tmp = url.split("?");
			/*if (tmp[1].length == 0) {
				url = tmp[0];
			}*/
		//url = tmp[0];
		/*}*/
		//console.log(url)

		history.pushState(null, '', url);

		this.trixScriptIndex = 0;
		this.trixScripts = [
			PLUNGE_SETTINGS.paths.BASE_URL_STORE + "customs/js/Customs.js",
			PLUNGE_SETTINGS.paths.BASE_URL_STORE + "customs/js/SceneList.js",
			PLUNGE_SETTINGS.paths.BASE_URL_STORE_DATA + "krpano.js"
		]

		// Carica dinamicamente alcuni assets
		jQuery(".js-image-hud").attr("src", PLUNGE_SETTINGS.paths.IMAGE_MAP + "?v=" + PLUNGE_SETTINGS.version.TRIX_ASSETS_VERSION);


		// Forza dentro labels dei valori che arrivano da fuori
		Labels.LABELS.push(
			{
				"value_fr": "",
				"value_en": "",
				"value_it": PLUNGE_SETTINGS.customs.introTitle_it,
				"value_de": "",
				"value_es": "",
				"id": "introTitolo"
			}
		);
		Labels.LABELS.push(
			{
				"value_fr": "",
				"value_en": "",
				"value_it": PLUNGE_SETTINGS.customs.introText_it,
				"value_de": "",
				"value_es": "",
				"id": "introDescrizione"
			}
		);


		// Carica gli script necessari
		this.loadNextScript();


		$(document).on('contextmenu', function (e) {
			// stop long touch hold from poping up context menus
			return false;
		});

	}

	loadNextScript() {
		//jQuery.getScript(PLUNGE_SETTINGS.paths.BASE_URL + trixScripts[trixScriptIndex]+"?v="+PLUNGE_SETTINGS.version.TRIX_ASSETS_VERSION, scriptLoaded);
		$.ajax({
			url: this.trixScripts[this.trixScriptIndex] + "?v=" + PLUNGE_SETTINGS.version.TRIX_ASSETS_VERSION,
			dataType: "script",
			success: this.scriptLoaded.bind(this),
			cache: true
		});
	}

	scriptLoaded() {
		// Setta le inizializzazioni custom o il caricamento di risorse customs
		
		try {
			Customs.init();
			Customs.pathResources = PLUNGE_SETTINGS.paths.BASE_URL_STORE_DATA + "main.xml"

			this.setPhoneLayout();
		} catch (e) {

		}

		this.trixScriptIndex++;
		if (this.trixScriptIndex >= this.trixScripts.length) {
			this.allScriptsLoaded();
		} else {
			this.loadNextScript();
		}
	}

	allScriptsLoaded() {

		let lng = this.userLangParam;
		if (lng) {
			if (PLUNGE_SETTINGS.language.SUPPORTED_LANGUAGES.indexOf(lng) >= 0) {
				this.userLang = lng;
			}
		} else {
			this.userLang = PLUNGE_SETTINGS.language.DEFAULT_LANGUAGE;
		}
		this.userLang = this.userLang.toUpperCase();

		if (PLUNGE_SETTINGS.language.SUPPORTED_LANGUAGES.indexOf(this.userLang) < 0) {
			this.userLang = PLUNGE_SETTINGS.language.SUPPORTED_LANGUAGES[1];
		}


		// aggiunge una classe di lingua ad alcuni tag di testo
		jQuery(".text-gallery").addClass("text-gallery-" + this.userLang.toLowerCase());

		if (this.scenename != null) {
			//let scene = Scene.getSceneByName(scenename)
			//startSpot = scene.spot;
			this.startSpot = this.scenename;
			if (this.scenename != 0) {
				this.track = true;
			}
		}


		this.url_rewrite = PLUNGE_SETTINGS.customs.url_rewrite;
		if (this.edit) {
			this.url_rewrite = false;
		}

		let preview = Pqp.getParameterByName("mode");
		if (preview == "preview") {
			this.url_rewrite = false;
		}


		let fhlookat = null;
		let fvlookat = null;

		if (this.hot_hotspot) {
			let a = SceneList.SCENE;
			let lFound = false;
			let tmp
			for (let x = 0; x < a.length; x++) {
				let b = a[x].hotspots
				if (b) {
					for (let y = 0; y < b.length; y++) {
						if (b[y].Uid == this.hot_hotspot) {
							tmp = b[y];
							lFound = true;
							break;
						}
					}
				}
				if (lFound) {
					break;
				}
			}
			if (tmp) {
				try {
					let scene = Scene.getSceneByName(Base64.decode(tmp.scene))
					this.startSpot = scene.spot;
					fhlookat = tmp.InfoJson.hlookat;
					fvlookat = tmp.InfoJson.vlookat;
				} catch (e) { 

				}
			}
		}

		if (this.hot_hotspot) {
			this.track = true;
		}

		//console.log("----->" + this.startSpot)
		/*if (this.startSpot === 0) {
			this.startSpot = 30;
		}*/
		this.trixMain = new Main(PLUNGE_SETTINGS.paths.BASE_URL, this.userLang, this.startSpot, this.skipwi, this.hot_hotspot, this.edit, this.hot_item, this.url_rewrite, fhlookat, fvlookat, this.track);
		this.trixMain.init();
	}

	setPhoneLayout() {
		
		if (!this.initedLayout) {
			this.initedLayout = true;
			let doIt = false;
			if (Pqp.isMobile()) {
				doIt = true;
			}
			if (PLUNGE_SETTINGS.customs.forcePhoneLayout) {
				doIt = true;
			}
			if (doIt) {
				// Toglie hedaer e footer
				/*jQuery("header").parent().remove();
				jQuery("header").remove();
				jQuery("footer").remove();*/

				jQuery("header").parent().hide();
				jQuery("header").hide();
				jQuery("footer").hide();


				jQuery(".content-header-fixed").css("padding-top", 0);

				//jQuery("body").css("font-size", "0"); 
				jQuery("body").css("background-color", "#ffffff"); 

				jQuery(".js-trix-ingombro-image").remove();
				jQuery(".js-trix1010").css({
					width: "100%"
				});
				jQuery(window).on("resize.dimmob", this.setContent.bind(this));
				this.setContent();
			}
		}
	}

	setContent() {
		var h = jQuery(window).height();
		jQuery("body").css("height", h);
		jQuery("body").css("width", "99.9vw");
		jQuery(".js-trix1010").height(h)
	}

	onViewChanged() {
		trixMain.onViewChanged();
	}

	getScreenshot() {
		Main.that.getScreenshot();
	}

	test() {

	}

}


